import PropTypes from "prop-types"
import React from "react"

import Logo from "../images/my-radar-logo.png"
import Gradient from "../images/gradient.png"
import Hamburger from "../images/icon-hamburger.svg"
import Close from "../images/icon-close.svg"

import IconFacebook from "../images/icon-facebook.png"
import IconInstagram from "../images/icon-instagram.png"
import IconX from "../images/icon-x.png"
import IconYouTube from "../images/icon-youtube.png"

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      scroll: 0,
      gradientPosition: 0,
      headerClass: "inactive",
    }
    this.updateScroll = this.updateScroll.bind(this)
    this.mobileNavToggle = this.mobileNavToggle.bind(this)
  }

  mobileNavToggle() {
    var mobileNavDrawer = document.getElementById("mobile-nav-drawer")
    var mobileNav = document.getElementById("mobile-nav")
    var body = document.getElementsByTagName("BODY")[0]

    mobileNavDrawer.classList.toggle("active")
    mobileNav.classList.toggle("active")
    body.classList.toggle("slide-out-open")
  }

  componentDidMount() {
    window.addEventListener("scroll", this.updateScroll)
  }

  updateScroll() {
    let hero = document.querySelector(".hero-content")

    if (!hero) return false

    let height = hero.offsetHeight

    let distance = window.scrollY

    let gradient

    if (window.innerWidth > 1320) gradient = distance * 0.035

    if (distance < height) {
      this.setState({
        scroll: distance,
        gradientPosition: gradient,
      })
    }

    if (distance > height - 150) {
      this.setState({
        headerClass: "active",
      })
    } else {
      this.setState({
        headerClass: "inactive",
      })
    }
  }

  render() {
    return (
      <React.Fragment>
        <header className={this.state.headerClass}>
          <div className="inner">
            <a href="/">
              <img src={Logo} alt="MyRadar" className="logo" />
            </a>

            <img
              src={Gradient}
              alt="MyRadar"
              className="gradient"
              style={{
                transform: `translateY(-${this.state.gradientPosition}%)`,
              }}
            />

            <nav>
              <ul>
                <li>
              <a href="/news">News</a>
            </li>

            <li>
              <a href="https://business.myradar.com">Business</a>
            </li>
                
                <li>
              <a href="https://store.myradar.com">Store</a>
            </li>

                <li className="download">
                  <a href="https://go.onelink.me/ebEx/a3553bd0">Download</a>
                </li>
              </ul>

              <button id="mobile-nav" onClick={this.mobileNavToggle} href="#">
                <img
                  src={Hamburger}
                  alt="Mobile Navigation"
                  className="hamburger-icon"
                />
                <img
                  src={Close}
                  alt="Mobile Navigation"
                  className="close-icon"
                />
              </button>
            </nav>
          </div>
        </header>

        <div id="mobile-nav-drawer">
          <div className="inner">
            <nav>
              <ul>
                {/*<li className="active">
              <a href="/">Consumer Application</a>
            </li>

            <li>
              <a href="/capabilities-listing">Commercial Capabilities</a>
            </li>*/}

                <li className="download">
                  <a href="/">Download</a>
                </li>
              </ul>
            </nav>

            <div className="header-social">
              <a
                href="https://facebook.com/MyRadar"
                className="logo logo--social"
              >
                <img src={IconFacebook} alt="facebook logo" />
              </a>
              <a
                href="https://youtube.com/myradar"
                className="logo logo--social"
              >
                <img src={IconYouTube} alt="youtube logo" />
              </a>
              <a
                href="https://x.com/myradarwx"
                className="logo logo--social"
              >
                <img src={IconX} alt="X logo" />
              </a>
              <a
                href="https://instagram.com/myradar"
                className="logo logo--social"
              >
                <img src={IconInstagram} alt="instagram logo" />
              </a>
            </div>

            <p className="copy">
              © 2018 Acme Atron-O-Matic, LLC <br />
              <a href="https://business.myradar.com/contact">Contact Us</a>
              <br />
              <a href="/privacy">Privacy Policy</a> <br />
              <a href="/california-notice">
                {" "}
                Notice to California Residents
              </a>{" "}
              <br />
              Do Not Sell My Information
            </p>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
